import { api } from './api';
import { ApiResponse } from './api';

export interface LoginCredentials {
  email: string;
  password: string;
  tenantId?: number;
  warehouseId?: number;
}

export interface AuthResponse {
  data: {
    accessToken: string;
    refreshToken?: string;
    user: {
      id: number;
      tenantId: number;
      warehouseId?: number | null;
      defaultWarehouseId?: number | null;
      activeWarehouseId?: number | null;
      canAccessAllWarehouses?: boolean;
      warehouse?: {
        id: number;
        name: string;
        status: string;
      } | null;
      actorTenantId?: number;
      effectiveTenantId?: number;
      isImpersonating?: boolean;
      tenant: {
        id: number;
        name: string;
        status: string;
      } | null;
      email: string;
      name: string | null;
      phone: string | null;
      status: string;
      createdAt: string;
      updatedAt: string;
      permissions: string[];
      role: {
        id: number;
        name: string;
        description?: string | null;
        permissions: string[];
      };
    };
  };
}

export const authService = {
  login: async (
    email: string,
    password: string,
    tenantId?: number,
    warehouseId?: number,
  ): Promise<AuthResponse | { requiresOtp: true; otpSessionId: string; email: string }> => {
    const response = await api.post('/auth/login', {
      email,
      password,
      ...(tenantId ? { tenantId } : {}),
      ...(warehouseId ? { warehouseId } : {}),
    });
    return response as any;
  },

  verifyOtp: async (otpSessionId: string, code: string): Promise<AuthResponse> => {
    const response = await api.post('/auth/verify-otp', { otpSessionId, code });
    return response as AuthResponse;
  },

  resendOtp: async (otpSessionId: string): Promise<{ otpSessionId: string; email: string }> => {
    const response = await api.post('/auth/resend-otp', { otpSessionId }) as any;
    return response?.data ?? response;
  },

  logout: async (): Promise<ApiResponse<void>> => {
    return api.post('/auth/logout');
  },

  forgotPassword: async (email: string): Promise<ApiResponse<void>> => {
    return api.post('/auth/forgot-password', { email });
  },

  resetPassword: async (token: string, password: string): Promise<ApiResponse<void>> => {
    return api.post('/auth/reset-password', { token, newPassword: password });
  },
};
